
import { $color } from "@/utils/cssVarUtils"
import type { SystemStyleObject } from "@chakra-ui/theme-tools"

const baseStyle: SystemStyleObject = {
  _focus: {
    boxShadow: "none",
  },
  _hover: {
    color: $color('scene-primary-normal'),
  }
}

export const Link = {
  baseStyle,
}